<template>
  <div>
    <VueFinalModal
      v-model="showModal"
      :esc-to-close="true"
      @closed="closed"
      class="modal-container"
      content-class="modal-content5"
    >
      <!-- Header -->
      <div
        style="
          display: flex;
          justify-content: space-between;
          padding: 1rem 2rem;
        "
      >
        <p style="font-size: 1rem; font-weight: 600; margin: 0">
          Referido: {{ referralName }}
        </p>
        <button
          type="button"
          class="btn-close"
          @click="closed"
          aria-label="Cerrar"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>

      <!-- Loading State -->
      <div v-if="loading" class="loading-state">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Cargando...</span>
        </div>
        <p>Cargando historial de notas...</p>
      </div>

      <!-- Notes List - Simple Style -->
      <div v-else-if="notes && notes.length > 0" class="notes-container">
        <label class="notes-label">
          <i class="fas fa-clipboard-list me-2"></i> Historial de Notas:</label
        >
        <div v-for="(note, index) in notes" :key="index" class="notesContainer">
          <p class="note-content">
            <span class="note-number">{{ index + 1 }}</span>
            {{ note.note }}
          </p>
          <div class="note-time-container">
            <p class="note-date">
              {{ note.date }}
            </p>
            <p class="note-relative-time">
              <i class="fas fa-clock me-1"></i>
              {{ getRelativeTime(note.date) }}
            </p>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div v-else class="empty-state">
        <div class="empty-icon">
          <i class="fas fa-inbox"></i>
        </div>
        <h5>No hay notas registradas</h5>
        <p>Este referido aún no tiene notas en su historial</p>
      </div>

      <!-- Footer -->
      <!-- <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="closed">
          <i class="fas fa-times me-2"></i>
          Cerrar
        </button>
      </div> -->
    </VueFinalModal>
  </div>
</template>

<script>
import { VueFinalModal } from "vue-final-modal";
import "vue-final-modal/style.css";

export default {
  name: "ModalNotesHistory",
  components: {
    VueFinalModal,
  },
  props: {
    notes: {
      type: Array,
      default: () => [],
    },
    referralName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showModal: false,
      loading: false,
    };
  },
  methods: {
    getRelativeTime(dateString) {
      // Parse date string format "13/06/2025, 11:31"
      const [datePart, timePart] = dateString.split(", ");
      const [day, month, year] = datePart.split("/");
      const [hours, minutes] = timePart.split(":");

      // Create Date object (month is 0-indexed in JavaScript)
      const date = new Date(year, month - 1, day, hours, minutes);
      const now = new Date();

      const diffInMinutes = Math.floor((now - date) / 60000);
      const diffInHours = Math.floor(diffInMinutes / 60);
      const diffInDays = Math.floor(diffInHours / 24);
      const diffInMonths = Math.floor(diffInDays / 30);
      const diffInYears = Math.floor(diffInDays / 365);

      if (diffInMinutes < 1) {
        return "Hace un momento";
      } else if (diffInMinutes < 60) {
        return `Hace ${diffInMinutes} minuto${diffInMinutes !== 1 ? "s" : ""}`;
      } else if (diffInHours < 24) {
        return `Hace ${diffInHours} hora${diffInHours !== 1 ? "s" : ""}`;
      } else if (diffInDays < 30) {
        return `Hace ${diffInDays} día${diffInDays !== 1 ? "s" : ""}`;
      } else if (diffInMonths < 12) {
        return `Hace ${diffInMonths} mes${diffInMonths !== 1 ? "es" : ""}`;
      } else {
        return `Hace ${diffInYears} año${diffInYears !== 1 ? "s" : ""}`;
      }
    },

    closed() {
      this.showModal = false;
      this.$emit("closed");
    },

    show() {
      this.showModal = true;
    },
  },
};
</script>

<style scoped>
.modal__content {
  background: white;
  border-radius: 12px;
  padding: 0;
  max-width: 600px;
  width: 90%;
  max-height: 80vh;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}

/* Header */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  background: linear-gradient(135deg, #7d0c7e, #9d4edd);
  color: white;
  border-radius: 12px 12px 0 0;
}

.header-content {
  flex: 1;
}

.modal-title {
  margin: 0 0 0.25rem 0;
  font-size: 1.2rem;
  font-weight: 600;
  display: flex;
  align-items: center;
}

.referral-name {
  margin: 0;
  opacity: 0.9;
  font-size: 0.9rem;
  font-weight: 400;
  padding: 0;
}

.btn-close {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: black;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-close:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

/* Loading State */
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
  color: #6c757d;
}

.spinner-border {
  color: #7d0c7e;
  margin-bottom: 1rem;
}

/* Notes Container - Simple Style */
.notes-container {
  padding: 0 2rem 2rem 2rem;
  max-height: 400px;
  overflow-y: auto;
}

.notes-label {
  font-weight: bold;
  color: #333;
  margin-bottom: 1rem;
  display: block;
  font-size: 1rem;
}

.notesContainer {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0.75rem 0;
  border-bottom: 1px solid #e9ecef;
  gap: 1rem;
}

.notesContainer:last-child {
  border-bottom: none;
}

.note-content {
  margin: 0 0 0 8px;
  display: flex;
  gap: 8px;
  flex: 1;
  line-height: 1.5;
  color: #333;
}

.note-number {
  font-size: 10px;
  align-self: center;
  background: #7d0c7e;
  color: white;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  flex-shrink: 0;
}

.note-date {
  margin: 0 8px 0 0;
  font-style: italic;
  font-size: 11px;
  color: #979797;
  white-space: nowrap;
  flex-shrink: 0;
}

.note-time-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  flex-shrink: 0;
}

.note-relative-time {
  margin: 0 8px 0 0;
  font-style: italic;
  font-size: 10px;
  color: #979797;
  white-space: nowrap;
  flex-shrink: 0;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 3rem 2rem;
  color: #6c757d;
}

.empty-icon {
  font-size: 4rem;
  color: #dee2e6;
  margin-bottom: 1rem;
}

.empty-state h5 {
  color: #495057;
  margin-bottom: 0.5rem;
}

/* Footer */
.modal-footer {
  padding: 1rem 2rem;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  display: flex;
  justify-content: flex-end;
}

.btn {
  padding: 0.5rem 1.5rem;
  border-radius: 6px;
  border: none;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
}

.btn-secondary {
  background: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background: #5a6268;
  transform: translateY(-1px);
}

/* Responsive */
@media (max-width: 768px) {
  .modal__content {
    width: 95%;
    max-height: 90vh;
  }

  .modal-header {
    padding: 1rem;
  }

  .modal-title {
    font-size: 1.1rem;
  }

  .notes-container {
    padding: 1.5rem;
  }

  .notesContainer {
    flex-direction: column;
    gap: 0.5rem;
    align-items: flex-start;
  }

  .note-time-container {
    flex-direction: row;
    align-items: center;
    gap: 8px;
    align-self: flex-end;
  }

  .note-date {
    margin: 0;
  }

  .note-relative-time {
    margin: 0;
  }

  .modal-footer {
    padding: 1rem;
  }
}

/* Custom scrollbar */
.notes-container::-webkit-scrollbar {
  width: 6px;
}

.notes-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.notes-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.notes-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
